<template>
  <div v-bind:class="{ 'op--modal-container': true, hide: !show }">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="update-reservation small-margin-v-s">
          <div v-show="!updating">
            <div class="title">{{ $t('rsvpEdit.confirmUpdate') }}</div>
            <div class="message margin-b-s" v-show="message !== ''" v-html="message"></div>
            <div class="message margin-b-m">{{ $t('rsvpEdit.updateRsvp2') }}</div>
            <a class="op-btn btn-lg btn-block btn-success" href="javascript:;" @click="update">{{ $t('rsvpEdit.yesUpdate') }}</a>
            <a class="cancel-btn margin-t-s" href="javascript:;" @click="close">{{ $t('rsvpEdit.noCancel') }}</a>
          </div>

          <div class="loaderx" v-show="updating">
            <div v-show="!done">
              <i class="fa fa-2x fa-circle-notch fa-spin"></i>
              <div class="margin-t-xs">{{ $t('rsvpEdit.updatingRsvpp') }}</div>
            </div>
            <div v-show="done">
              <div v-show="success">
                <i class="fa fa-3x fa-check-circle"></i>
                <div class="margin-t-xs">{{ $t('rsvpEdit.successUpdate') }}</div>
                <a class="cancel-btn margin-t-xs" href="javascript:;" @click="closeEdit">{{ $t('rsvpEdit.okUpdate') }}</a>
              </div>
              <div v-show="!success">
                <i class="fa fa-3x fa-times-circle"></i>
                <div class="margin-t-xs">{{ errorLabel.message }}</div>
                <a class="cancel-btn margin-t-xs" href="javascript:;" @click="close">{{ errorLabel.button }}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment-timezone'
import featureToggle from '@/modules/api/featureToggle'
import { isValidNumber } from 'libphonenumber-js'
export default {
  name: 'update-reservation',
  data () {
    return {
      message: '',
      updating: false,
      done: false,
      success: false,
      errorLabel: {
        message: this.$t('rsvpEdit.oops'),
        button: this.$t('rsvpEdit.tryAgain')
      },
      submitLoading: false
    }
  },
  computed: {
    show () { return this.$store.state.rsvpEdit.update.show },
    original () { return this.$store.state.rsvpEdit.originalRsvp },
    edited () { return this.$store.state.rsvpEdit.editedRsvp },
    services () { return this.$store.state.rsvpEdit.serviceSelection.services },
    service () { return this.$store.state.rsvpEdit.serviceSelection.selectedService },
    isUSPhone () {
      let userPhone = this.original.consumer.phones[0]
      userPhone = userPhone.countryCode + userPhone.phoneNumber
      return isValidNumber(userPhone, 'US') || isValidNumber(userPhone, 'CA')
    },
    isMeetAndGreetEnabled () {
      let self = this
      if (self.services === null) {
        return false
      }
      let serviceCode = self.edited.serviceCode
      let service = self.services[serviceCode]
      let selectedService = self.$store.state.rsvpEdit.serviceSelection.selectedService
      if (selectedService !== null) {
        service = selectedService
      }

      return service.meetAndGreet
    },
    isMeetAndGreetOnly () {
      let self = this
      let services = self.$store.state.rsvpEdit.serviceSelection.services
      if (services === null) {
        return false
      }
      let serviceCode = self.$store.state.rsvpEdit.editedRsvp.serviceCode
      let service = services[serviceCode]
      let selectedService = self.$store.state.rsvpEdit.serviceSelection.selectedService
      if (selectedService !== null) {
        service = selectedService
      }

      return service.meetAndGreet && !service.curbside
    },
    charter () { return this.$store.state.reservation.charter },
    optin () { return this.$store.state.reservation.optin.leg1 },
    discountCode () { return this.$store.state.discountCode },
    flightStore () { return this.$store.state.flights }
  },
  methods: {
    getHolidayPrice () {
      if (!CONFIG.useOldQuatation) { return 0 }
      return 0
    },
    getFare () {
      let self = this
      let passengers = self.edited.passengers
      let service = self.service
      if (self.charter.enabled) {
        let rsvpEdit = self.$store.state.rsvpEdit
        let code = rsvpEdit.serviceSelection.selectedService ? rsvpEdit.serviceSelection.selectedService.code : rsvpEdit.editedRsvp.serviceCode
        service = self.services[code]
      }
      let holidayPrice = self.getHolidayPrice(service)
      let price = service.prices[passengers - 1].price
      if (holidayPrice > 0) {
        price = service.prices[passengers - 1].original + holidayPrice
      }
      return price
    },
    close () { this.$store.commit('rsvpEdit/hideUpdate') },
    closeEdit () {
      this.$store.commit('reservation/setOptinData', {
        leg: 'leg1',
        fields: {enabled: false}
      })
      this.close()
      // this.$root.$router.push('search-edit')
      this.$root.$router.push('search')
      document.body.classList.remove('widget-full')
    },
    update () {
      let self = this
      if (self.submitLoading) return
      self.submitLoading = true

      let payload = self.buildPayload()

      self.updating = true
      let url = '/reservations/' + self.original.id + '/' + self.original.consumer.firstName + '/' + self.original.consumer.lastName
      self.$sdk.post(self, url, payload, r => {
        self.submitLoading = false
        self.done = true
        if (r.error) {
          if (r.error.message && r.error.message.includes('Duplicate reservation')) {
            self.success = true
            return
          }
          self.errorLabel.message = self.$t('rsvpEdit.oops')
          self.errorLabel.button = self.$t('rsvpEdit.tryAgain')
          self.success = false
          if (r.error.code === 'GATE401002') {
            self.errorLabel.message = r.error.message
            self.errorLabel.button = self.$t('common.close')
          }
          if (r.error.code === 'GATE402001') {
            self.errorLabel.message = self.$t('rsvpEdit.failUpdate')
            self.errorLabel.button = self.$t('common.close')
          }
          return
        }
        self.success = true
      })
    },
    buildPayload () {
      let self = this
      let rsvpEdit = self.$store.state.rsvpEdit
      let originalPayment = self.original.payment
      let selectedService = self.service
      let code = rsvpEdit.serviceSelection.selectedService ? rsvpEdit.serviceSelection.selectedService.code : rsvpEdit.editedRsvp.serviceCode
      if (self.charter.enabled) {
        selectedService = rsvpEdit.serviceSelection.services[code]
      }
      let originalFare = self.original.originalPrice
      if (selectedService !== null) {
        originalFare = selectedService.prices[self.edited.passengers - 1].original
      }
      let fare = selectedService !== null ? self.getFare() : originalPayment.fare
      let tip = self.original.payment.tip
      let airportFee = selectedService !== null ? selectedService.airportFee : originalPayment.airportFee
      let gasFee = selectedService !== null ? selectedService.gasFee : self.original.gasFee
      let travelInsurance = selectedService !== null ? selectedService.travelInsurance : originalPayment.travelInsurance
      let isMeetAndGreet = self.edited.pickupType === 'MeetAndGreet'
      let totalAmount = fare + gasFee + airportFee + travelInsurance + tip
      let pickupFee = 0
      if (self.isMeetAndGreetEnabled && (isMeetAndGreet || !self.isUSPhone || self.isMeetAndGreetOnly)) {
        pickupFee = (selectedService !== null ? selectedService.pickupFee : self.services[code].pickupFee)
        totalAmount += pickupFee
      }
      let pickupType = null
      if (self.edited.pickup.geofenceType === 'airport') {
        pickupType = 'Curbside'
        if (self.isMeetAndGreetEnabled && (isMeetAndGreet || !self.isUSPhone || self.isMeetAndGreetOnly)) {
          pickupType = 'MeetAndGreet'
        }
      }
      let pickup = {
        title: self.edited.pickup.title,
        address1: self.edited.pickup.addressLine1,
        address2: self.edited.pickup.addressLine2,
        city: self.edited.pickup.city,
        state: self.edited.pickup.state,
        zip: self.edited.pickup.zip,
        lat: self.edited.pickup.lat,
        lng: self.edited.pickup.lng,
        geofenceId: self.edited.pickup.geofenceId
      }
      let dropoff = {
        title: self.edited.dropoff.title,
        address1: self.edited.dropoff.addressLine1,
        address2: self.edited.dropoff.addressLine2,
        city: self.edited.dropoff.city,
        state: self.edited.dropoff.state,
        zip: self.edited.dropoff.zip,
        lat: self.edited.dropoff.lat,
        lng: self.edited.dropoff.lng,
        geofenceId: self.edited.dropoff.geofenceId
      }
      let flightNumber = ''
      let flightName = ''
      let flightNumberDropoff = ''
      let flightNameDropoff = ''
      if (self.edited.pickup.geofenceType === 'airport') {
        flightNumber = self.edited.flightNumber
        flightName = self.edited.airline
      }
      if (self.edited.pickup.geofenceType !== 'airport' && self.edited.dropoff.geofenceType === 'airport') {
        flightNumberDropoff = self.edited.flightNumber
        flightNameDropoff = self.edited.airline
      }

      let brands = Object.keys(CONFIG.Brands)
      let brandId = self.edited.brandID
      let index = Object.values(CONFIG.Brands).findIndex(x => x.id === brandId)
      let isHudson = CONFIG.Brands[brands[index]].code === 'pts'
      // let isHudson = true

      let payload = {
        token: '',
        brandId: self.edited.brandID,
        guest: {
          firstName: self.edited.guest.firstName,
          lastName: self.edited.guest.lastName,
          mobile: self.edited.guest.phone,
          countryCode: ''
        },
        legs: [
          {
            pickup: pickup,
            dropoff: dropoff,
            pickupTime: moment.tz(self.edited.pickupTime, 'MM/DD/YYYY ' + featureToggle.timeFormat(self, false), self.$store.state.rsvpEdit.editedRsvp.pickupTimezone).format('X'),
            passengers: self.edited.passengers,
            luggage: self.edited.luggage,
            amount: fare,
            originalPrice: originalFare,
            flightNumber: flightNumber,
            flightName: flightName,
            dropoffFlightName: flightNameDropoff,
            dropoffFlightNumber: flightNumberDropoff,
            asap: false,
            etaInSec: self.edited.eta,
            serviceTypeId: self.service !== null ? self.service.id : self.services[code].id,
            serviceType: self.service !== null ? self.service.code : self.services[code].code,
            pickupType: pickupType,
            pickupFee: pickupFee,
            distance: self.edited.distance,
            notes: self.edited.notes,
            airportFee: airportFee,
            travelInsurance: travelInsurance,
            gasFee: gasFee
          },
          null
        ],
        wheelchair: self.edited.ada.wheelchair,
        serviceDog: self.edited.ada.serviceDog,
        payment: {
          cardID: self.original.cardID,
          tip: tip,
          total: totalAmount,
          fare: fare,
          pickupFee: pickupFee,
          promo: 0
        },
        source: 'C',
        deviceType: 'ww',
        hudson: isHudson
      }
      if (self.edited.extraStops && self.edited.extraStops.length) {
        payload.legs[0].extraStops = []
        self.edited.extraStops.forEach(stop => {
          payload.legs[0].extraStops.push({
            address1: stop.address1,
            address2: stop.address2,
            city: stop.city,
            state: stop.state,
            zip: stop.zip,
            lat: stop.lat,
            lng: stop.lng,
            title: stop.title
          })
        })
      }
      if (this.charter.enabled) {
        let startDate = moment(this.charter.startDate, 'MM/DD/YYYY hh:mmA')
        let endDate = moment(this.charter.endDate, 'MM/DD/YYYY hh:mmA')
        payload.isCharter = true
        payload.legs[0].pickupTime = startDate.format('X')
        payload.legs[0].etaInSec = endDate.diff(startDate, 'seconds')
        payload.legs[0].airportGeofenceId = this.edited.pickup.geofenceType === 'airport' ? this.charter.airportGeoId : null
        delete payload.legs[0].dropoff
        delete payload.legs[0].distance
        delete payload.legs[0].dropoffFlightName
        delete payload.legs[0].dropoffFlightNumber
        delete payload.legs[0].travelInsurance
      }
      if (this.optin.enabled) {
        let origPrice = self.services[code].prices[(self.edited.passengers || 1) - 1].price
        let percent = self.services[code].optinPercent / 100
        percent = parseFloat((1 - percent).toFixed(2))
        payload.legs[0].optinShared = {
          serviceTypeId: self.services[code].id,
          amount: parseFloat((origPrice * percent).toFixed(2))
        }
      }
      if (self.original.isCorporate && self.original.discountCode) {
        payload.discountCodeAmount = selectedService.prices[self.edited.passengers - 1].discount
        payload.discountCode = self.original.discountCode
      }
      if (self.flightStore.edit.id === self.original.id) {
        payload.d2dId = self.flightStore.selected.id
      }

      payload.d2dPayment = 1
      return payload
    }
  },
  watch: {
    show (value) {
      if (!value) {
        return
      }
      let self = this
      self.updating = false
      self.done = false
      self.success = false
      self.message = ''

      let originalPrice = self.original.payment.total + self.original.gasFee
      let newPrice = null
      let rsvpEdit = self.$store.state.rsvpEdit
      let code = rsvpEdit.serviceSelection.selectedService ? rsvpEdit.serviceSelection.selectedService.code : rsvpEdit.editedRsvp.serviceCode
      if (self.service !== null) {
        newPrice = self.getFare() + self.service.airportFee + self.service.gasFee + self.service.travelInsurance + self.original.payment.tip
        if (self.isMeetAndGreetEnabled && (self.edited.pickupType === 'MeetAndGreet' || !self.isUSPhone || self.isMeetAndGreetOnly)) {
          newPrice += self.service.pickupFee
        }
      } else {
        let pickupFee = 0
        if (self.isMeetAndGreetEnabled && (self.edited.pickupType === 'MeetAndGreet' || !self.isUSPhone || self.isMeetAndGreetOnly)) {
          pickupFee = self.services[code].pickupFee
        }
        newPrice = self.original.payment.fare + self.original.payment.airportFee + self.original.gasFee + self.original.payment.travelInsurance + pickupFee + self.original.payment.tip
        if (self.charter.enabled) {
          let service = self.services[code]
          newPrice = service.prices[self.edited.passengers - 1].price + service.airportFee +
            service.travelInsurance + pickupFee + self.original.payment.tip
        }
      }

      if (originalPrice === newPrice) {
        return
      }
      if (originalPrice < newPrice) {
        let additional = newPrice - originalPrice
        self.message = `${self.$t('rsvpEdit.dueCharged')} $${additional.toFixed(2)} ${self.$t('rsvpEdit.yourCard')}`
        return
      }
      let newPriceWithPromo = newPrice - self.original.payment.promo
      if (originalPrice > newPriceWithPromo && newPriceWithPromo >= 0) {
        let refund = originalPrice - newPrice
        self.message = `${self.$t('rsvpEdit.dueRefund')} $${refund.toFixed(2)} ${self.$t('rsvpEdit.yourCard')}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.update-reservation {
  background-color: #fff;
  max-width: 350px;
  margin: 10px auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);

  & .title {
    text-align: center;
    font-weight: 700;
    margin-bottom: 15px;
  }

  & .message {
    text-align: center;
  }
}

.loaderx {
  text-align: center;
  color: #777;

  & .fa-check-circle { color: #26D97A; }
  & .fa-times-circle { color: #F20D0D; }
}

.cancel-btn {
  display: block;
  text-align: center;
  color: #cb8112;
}
</style>



// WEBPACK FOOTER //
// UpdateReservation.vue?6e5f7d7e